/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { fontsize14, poppins500 } from 'theme/common.style';
import { offerStatusCont } from './LabelHeader.style';

function LabelHeader(props) {
  const { labelValue, icon } = props;
  return (
    <Typography component="div" sx={offerStatusCont}>
      <Typography
        sx={{
          ...poppins500,
          fontSize: '14px',
          color: '#112347',
        }}
      >
        {labelValue}
      </Typography>
      {icon ? (
        <Typography>
          <img src={icon} alt="icon" hwight={29} width={29} />
        </Typography>
      ) : null}
    </Typography>
  );
}

LabelHeader.defaultProps = {
  icon: '',
};

LabelHeader.propTypes = {
  labelValue: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default LabelHeader;
